import React, { useEffect } from "react"
import { FormattedMessage } from "react-intl"
import { Link as RouterLink } from "react-router-dom"
import { styled } from "@mui/material/styles"
import MenuIcon from "@mui/icons-material/Menu"
import ArrowNextImage from "assets/images/buttons/ArrowNext.svg"
import {
  Button,
  Divider,
  Drawer,
  Grid,
  Link,
  List,
  ListItem,
  ListItemButton,
  Typography,
} from "@mui/material"
import clsx from "clsx"
import CloseBurgerMenu from "atoms/button/CloseBurgerMenu"
import InfoBadgeWrapper from "organisms/common/InfoBadgeWrapper"
import InfoIconUpdate from "organisms/common/InfoIconUpdate"
import { getLocaleJaOrEnInitialUpper, getTopPagePath } from "locale.js"

const StyledList = styled(List)(({ theme }) => ({
  width: "320px",
  paddingTop: "5px",
}))

const StyledListItem = styled(ListItemButton)(({ theme }) => ({
  padding: 0,
}))

const BurgerMenuTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "HiraKakuProN-W6",
  fontSize: "18px",
  lineHeight: "normal",
  letterSpacing: "normal",
  color: "#727272",
  marginLeft: "24px",
}))

const BurgerMenuClose = styled(CloseBurgerMenu)(({ theme }) => ({
  fontFamily: "HiraKakuProN-W6",
  fontSize: "18px",
  lineHeight: "normal",
  letterSpacing: "normal",
  color: "#727272",
  marginRight: "10px",
  marginTop: "10px",
  marginBottom: "15px",
}))

const TextDiv = styled("div")(({ theme }) => ({
  fontFamily: "HiraKakuProN-W3",
  fontSize: "16px",
  lineHeight: 1.27,
  letterSpacing: "normal",
  color: "#3374da",
  marginRight: "10px",
  marginLeft: "24px",
  marginTop: "10px",
  marginBottom: "10px",
  "&::after": {
    content: "''",
    display: "inline-block",
    width: "15px",
    height: "13px",
    margin: "1px 0 0 5px",
    background: `url(${ArrowNextImage}) 0 0 / 100% 100% no-repeat`,
  },
}))

const StyledDivider = styled(Divider)(({ theme }) => ({
  height: "1px",
  backgroundColor: "#dfe0e0",
  marginTop: "13px",
  marginBottom: "10px",
}))

const InformationDivider = styled(Divider)(({ theme }) => ({
  margin: "16px 24px 12px",
  backgroundColor: "#efefef",
}))

const InformationLink = styled(Link)(({ theme }) => ({
  "&:hover .hoverUnderLine": {
    textDecoration: "underline",
  },
}))

const UpdateGrid = styled(Grid)(({ theme }) => ({
  flexGrow: 1,
  textAlign: "right",
  marginRight: "34px",
}))

const MenuButton = styled(Button)(({ theme }) => ({
  position: "absolute",
  top: "12px",
  right: "0",
}))

const Menu = () => {
  const [state, setState] = React.useState(false)
  const toggleDrawer = (open) => (event) => {
    setState(open)
  }
  useEffect(() => {
    window.addEventListener("popstate", toggleDrawer(false))
  }, [])

  const dataGa = "menuToAccount" + getLocaleJaOrEnInitialUpper()

  const accountMenu = (
    <>
      <StyledListItem button component="li">
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item>
            <TextDiv>
              <Link
                href={process.env.REACT_APP_ACCOUNT_LINKAGE_URL}
                target="_blank"
                rel="noopener noreferrer"
                id="account"
                data-ga={dataGa}
                underline="hover"
              >
                <FormattedMessage
                  id="Menu.Account"
                  values={{
                    linebreak: <br />,
                  }}
                />
              </Link>
            </TextDiv>
          </Grid>
        </Grid>
      </StyledListItem>
    </>
  )
  const informationMenu = (
    <>
      <InformationDivider />
      <InformationLink
        component={RouterLink}
        to="/information"
        id="listInformation"
        underline={"none"}
        onClick={toggleDrawer(false)}
      >
        <StyledListItem button component="li">
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item>
              <TextDiv className="hoverUnderLine">
                <FormattedMessage id="Menu.Information" />
              </TextDiv>
            </Grid>
            <UpdateGrid item id="updateIcon">
              <InfoIconUpdate />
            </UpdateGrid>
          </Grid>
        </StyledListItem>
      </InformationLink>
    </>
  )
  const topList = {
    id: "top",
    path: getTopPagePath(),
    formattedId: "Menu.Top",
  }

  const displayAgreementList = {
    id: "displayAgreement",
    path: "/displayAgreement",
    formattedId: "Menu.DisplayAgreement",
  }

  const noticeConfigList = {
    id: "noticeConfig",
    path: "/noticeConfig",
    formattedId: "Menu.NoticeConfig",
  }

  const thirdPartList = {
    id: "thirdParty",
    path: "/thirdParty",
    formattedId: "Menu.ThirdParty",
  }

  const locationList = {
    id: "location",
    path: "/location",
    formattedId: "Menu.Location",
  }

  const menuFlagArray = [
    topList,
    displayAgreementList,
    thirdPartList,
    locationList,
    noticeConfigList,
  ]
  const customMenu = menuFlagArray.map((menus, index) => {
    return (
      <StyledListItem button>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item>
            <TextDiv>
              <Link
                component={RouterLink}
                to={menus.path}
                id={menus.id}
                onClick={toggleDrawer(false)}
                key={index}
                underline="hover"
              >
                <FormattedMessage id={menus.formattedId} />
              </Link>
            </TextDiv>
          </Grid>
        </Grid>
      </StyledListItem>
    )
  })

  return (
    <>
      <MenuButton id="menuIcon" onClick={toggleDrawer(true)}>
        <InfoBadgeWrapper>
          <MenuIcon color="action" />
        </InfoBadgeWrapper>
      </MenuButton>
      <Drawer anchor="right" open={state} onClose={toggleDrawer(false)}>
        <StyledList>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <BurgerMenuTitle>
                <FormattedMessage id="Menu.Title" />
              </BurgerMenuTitle>
            </Grid>
            <Grid item>
              <BurgerMenuClose
                onClick={toggleDrawer(false)}
                onKeyDown={toggleDrawer(false)}
                id="closeBurger"
              />
            </Grid>
          </Grid>
          <StyledDivider />
          {customMenu}
          {accountMenu}
          {informationMenu}
        </StyledList>
      </Drawer>
    </>
  )
}

export default Menu
